import * as React from "react";
import { createSvgIcon } from "@material-ui/core/utils";
export var iconPath = (React.createElement("path", { d: "M2 6h20V4H2v2zm20 7H2v-2h20v2zm0 7H2v-2h20v2z" }));
export default createSvgIcon(iconPath, "BurgerMenu");
//# sourceMappingURL=BurgerMenuIcon.js.map